"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _prismicElements = _interopRequireDefault(require("./prismicElements"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint complexity:0, react/no-this-in-sfc:0, no-invalid-this:0 */
var SerializeHtml = function serializeHtmlComponent(type, element, content, children, key) {
  var currentElement = _prismicElements["default"][type];
  var typeMod = currentElement.typeMod,
      Tag = currentElement.Tag,
      classMod = currentElement.classMod;
  var Component = this.components[typeMod];
  var renderProps = {
    index: key,
    element: element,
    content: content,
    children: children,
    baseClass: this.baseClass,
    currentClass: "".concat(this.baseClass).concat(classMod)
  };

  if (Component) {
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, renderProps, {
      key: (0, _v["default"])()
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(Tag, {
    className: renderProps.currentClass,
    key: (0, _v["default"])()
  }, children);
};

var _default = SerializeHtml;
exports["default"] = _default;